module.exports = __webpack_public_path__ + "static/media/ekebyalmby.aa4f82e8.jpeg";